@if (!!benefits?.length) {
  @if (!isMobile) {
    <section class="nutrient-benefits-list">
      <header class="nutrient-benefits-list__header">
        <p class="nutrient-benefits-list__title">{{ nutrientListTitle }}</p>
        <div class="nutrient-benefits-list__tags-legend">
          <span class="nutrient-benefits-list__tags-legend__item">
            <span>{{ 'sr-xray_column_title_Main_influencers' | translateKey }}</span>
            <span
              class="nutrient-benefits-list__info-icon"
              [matTooltipPosition]="'above'"
              matTooltipHideDelay="1"
              matTooltip="{{ 'sr-xray_main_influencers_popin' | translateKey }}"
              matTooltipClass="tooltip-arrow-down-light"
              #tooltip="matTooltip"
            >
              <app-icon class="nutrient-benefits-list__icon" [name]="IconName.info"></app-icon>
            </span>
          </span>
        </div>
      </header>
      <div class="nutrient-benefits-list__list-container">
        @for (benefit of benefits; track benefit.id) {
          <div class="nutrient-benefits-list__block">
            <div class="nutrient-benefits-list__item">
              <div class="nutrient-benefits-list__item__left">
                <span class="nutrient-benefits-list__bullet"></span>
                <p class="nutrient-benefits-list__benefit-label">{{ getNutrientLabel(benefit.id) }}</p>
              </div>
              <div class="nutrient-benefits-list__tag-list">
                @for (influencer of benefit.influencers; track influencer.key) {
                  <div class="nutrient-benefits-list__tag-item">
                    @let influencerLabel = getInfluencerLabel(influencer);
                    <span
                      class="nutrient-list__info-icon"
                      [matTooltipPosition]="'above'"
                      matTooltipHideDelay="1"
                      matTooltip="{{ 'description-criteria_consult' | translateKey }} {{ influencerLabel }} "
                      matTooltipClass="tooltip-arrow-down"
                      #tooltip="matTooltip"
                    >
                      @if (!!influencerLabel) {
                        <rc-tag
                          [size]="RCTagSize.XS"
                          [text]="influencerLabel"
                          [isInteractive]="true"
                          (click)="showInfluencerDescriptionPopin(influencer)"
                        ></rc-tag>
                      }
                    </span>
                  </div>
                }
              </div>
            </div>
            <hr class="nutrient-benefits-list__divider" />
          </div>
        }
      </div>
    </section>
  } @else {
    <section class="nutrient-benefits-list">
      <p class="nutrient-benefits-list__title__mobile">{{ nutrientListTitle }}</p>
      <div class="nutrient-benefits-list__list-container__mobile">
        @for (benefit of benefits; track benefit.id) {
          <div class="nutrient-benefits-list__item-mobile">
            <div class="nutrient-benefits-list__item__left-mobile">
              <span class="nutrient-benefits-list__bullet"></span>
              <p class="nutrient-benefits-list__benefit-label-mobile">{{ getNutrientLabel(benefit.id) }}</p>
            </div>
            <div class="nutrient-benefits-list__tags-legend-mobile">
              <span>
                {{ 'sr-xray_column_title_Main_influencers' | translateKey }}
              </span>
            </div>
            <div class="nutrient-benefits-list__tag-list-mobile">
              @let influencers = benefit.influencers;
              @if (influencers) {
                @for (influencer of influencers; track influencer.key) {
                  <div class="nutrient-benefits-list__tag-item">
                    @let influencerLabel = getInfluencerLabel(influencer);
                    @if (!!influencerLabel) {
                      <rc-tag [size]="RCTagSize.XS" [text]="influencerLabel"></rc-tag>
                    }
                  </div>
                }
              }
            </div>
            <hr class="nutrient-benefits-list__divider" />
          </div>
        }
      </div>
    </section>
  }
}
